import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutocompleteOption } from 'src/app/components/autocomplete/autocomplete-option';
import { DashboardCounts } from 'src/app/models/dashboard/dashboard-counts';
import { ReturnPendingQuote } from 'src/app/models/quote/return-pending-quote';
import { ReturnPendingRecommendation } from 'src/app/models/recommendation/return-pending-recommendation';
import { PostUserId } from 'src/app/models/user/post-user-id';
import { User } from 'src/app/models/user/user';
import { QuoteService } from 'src/app/services/quote/quote.service';
import { RecommendationService } from 'src/app/services/recommendation/recommendation.service';
import { UserDataService } from 'src/app/services/user-data/user-data.service';
import { UserAutocompleteDataLoaderService } from 'src/app/services/autocomplete-data-loader/user-autocomplete-data-loader.service';
import { UserService } from 'src/app/services/user/user.service';
import { RecommendationEditNavigationState } from 'src/app/models/recommendation/recommendation-edit-navigation-state';
import { QuoteEditNavigationState } from 'src/app/models/quote/quote-edit-navigation-state';
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { Title } from '@angular/platform-browser';
import { ToastControllerWrapperService } from 'src/app/services/toast-controller-wrapper/toast-controller-wrapper.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {

  title: string = 'Dashboard';
  user: User;
  counts: DashboardCounts;
  pendingQuotesUser: AutocompleteOption;
  pendingRecommendationsUser: AutocompleteOption;
  pendingQuotes: ReturnPendingQuote[] = null;
  pendingRecommendations: ReturnPendingRecommendation[] = null;

  constructor(
    private router: Router,
    private titleService: Title,
    private platform: Platform,
    private toastWrapper: ToastControllerWrapperService,
    private userService: UserService,
    private userData: UserDataService,
    private quoteService: QuoteService,
    private recommendationService: RecommendationService,
    public userAutoCompDataLoader: UserAutocompleteDataLoaderService
    ) {
  }

  ngOnInit() {
  }
  
  ionViewWillEnter() {
    this.userData.getUser().then(u => this.user = u);
    this.titleService.setTitle(this.title);
    this.platform.ready().then(() => SplashScreen.hide());
    this.loadDashboardCounts();
    this.loadPendingQuotes();
    this.loadPendingRecommendations();
  }

  loadDashboardCounts() {
    this.userService.getDashboardCounts()
      .subscribe(
        (data) => {
          if (data.success) {
            this.counts = data.payload.counts;
          }
        }
      );
  }

  loadPendingQuotes() {

    var postUserId = <PostUserId>{ id: null };
    if (this.pendingQuotesUser) {
      postUserId = <PostUserId>{ id: this.pendingQuotesUser.id };
    }

    this.quoteService.getPendingQuotes(postUserId)
      .subscribe(
        (data) => {
          if (data.success) {
            this.pendingQuotes = data.payload.quotes;
          }
        }
      );
  }

  loadPendingRecommendations() {
    var postUserId = <PostUserId>{ id: null };
    if (this.pendingRecommendationsUser) {
      postUserId = <PostUserId>{ id: this.pendingRecommendationsUser.id };
    }

    this.recommendationService.getPendingRecommendations(postUserId)
      .subscribe(
        (data) => {
          if (data.success) {
            this.pendingRecommendations = data.payload.recommendations;
          }
        }
      );
  }

  trackById(index: number, item: any): number {
    return item.id;
  }

  getItemCardHeight() {
    return 170;
  }

  goToRecommendation(recommendation: ReturnPendingRecommendation) {
    const customerAddressExists = recommendation.addressId !== null;

    if (customerAddressExists) {
      this.router.navigate(['recommendation', recommendation.id], {
        state: <RecommendationEditNavigationState>{
          recommendationId: recommendation.id,
          addressId: recommendation.addressId,
          addressType: recommendation.addressType
        }
      });
    } else {
      this.toastWrapper.presentErrorToast('Customer/Address not found.');
    }
  }

  goToQuote(quote: ReturnPendingQuote) {
    const customerAddressExists = quote.addressId !== null;

    if (customerAddressExists) {
      this.router.navigate(['quote', quote.id], {
        state: <QuoteEditNavigationState>{
          quoteId: quote.id,
          addressId: quote.addressId,
          addressType: quote.addressType
        }
      });
    } else {
      this.toastWrapper.presentErrorToast('Customer/Address not found.');
    }
  }
}
